<template>
  <div>
    <div class="form">
      <div class="form-item">
        <div class="label">用户类型</div>
        <div class="select" :class="{ 'active': cp_type && true || false }" @click="openSelect('cp_type')">
          <span v-if="!cp_type">请选择用户类型</span>
          <span v-else>{{ cp_type }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div v-show="cp_type === '乐队/组合'" class="form-item">
        <div class="label">乐队关系类型</div>
        <div class="select" :class="{ 'active': team_role && true || false }" @click="openSelect('team_role')">
          <span v-if="!team_role">请选择乐队关系类型</span>
          <span v-else>{{ team_role }}</span>
          <i class="iconfont icon-jiantou-xia"></i>
        </div>
      </div>
      <div class="form-item">
        <div class="label">艺名/乐队名</div>
        <div class="input"><input v-model="nickname" type="text" maxlength="20" placeholder="请输入您的艺名或者乐队名" ></div>
      </div>
      <div class="form-item">
        <div class="label">手机号</div>
        <div class="input"><input ref="mobile" v-model="mobile" type="number" maxlength="11" placeholder="手机号码（系统登录使用，请认真填写）" @input="limitNum($refs.mobile, 'mobile', 11)"></div>
      </div>
      <div class="form-item">
        <div class="label">验证码</div>
        <div class="input">
          <input v-model="code" type="text" maxlength="6" placeholder="请输入短信验证码" >
          <div v-if="count === 60" class="code" :class="{ 'active': isSendSms }" @click="isSendSms ? sendSms() : null">发送验证码</div>
          <div v-else class="code">{{ count }}s 重新发送</div>
        </div>
      </div>
      <div class="form-item">
        <div class="label">密码</div>
        <div class="input">
          <input v-model="password" :type="!showPwd ? 'password' : 'text'" maxlength="20" placeholder="8-20位密码" >
          <van-icon :name="!showPwd ? 'closed-eye' : 'eye-o'" class="fs-24" @click="showPwd = !showPwd" />
        </div>
      </div>
      <div class="mt-15 flex align-center justify-between">
        <router-link :to="{ path: isPlus ? '/children-reg' : 'children-reg-h5', query: $route.query }" class="color-0D0E15">未成年人注册</router-link>
        <div v-if="isPlus">
          <span class="mr-8">已有账号</span>
          <router-link :to="{ path: '/login', query: $route.query }" class="color-FC3159">马上登录</router-link>
        </div>
      </div>
      <span style="display: none;">{{ isFinished }}</span>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LimitNum from '@/mixins/number-limit.js'
export default {
  name: 'SingleReg',
  mixins: [LimitNum],
  props: {
    count: {
      type: Number
    }
  },
  data() {
    return {
      show: false,
      showPwd: false, // 默认是密文
      curKey: '', // 当前select的字段
      cp_type: '',
      nickname: '', // 艺名/乐队名/公司简称
      mobile: '',
      password: '',
      code: '',
      team_role: '',
      actions: []
    }
  },
  computed: {
    isSendSms() {
      return this.mobile.length  === 11
    },
    cpTypeOption() {
      return [{ name: '独立音乐人', color: this.cp_type === '独立音乐人' && '#0079FF' || '' }, { name: '乐队/组合', color: this.cp_type === '乐队/组合' && '#0079FF' || '' }]
    },
    teamRoleOption() {
      return [{ name: '主唱', color: this.team_role === '主唱' && '#0079FF' || '' }, { name: '乐手', color: this.team_role === '乐手' && '#0079FF' || '' }, { name: '实际运营管理者', color: this.team_role === '实际运营管理者' && '#0079FF' || '' }]
    },
    isFinished() {
      const { mobile, password, code, cp_type, nickname, team_role } = this
      let isFinished = mobile && password && code && cp_type && nickname
      if (this.cp_type === '乐队/组合') {
        isFinished = isFinished && team_role
      }
      this.$emit('finished', { isFinished, form: { mobile, password, code, cp_type, nickname, team_role }})
      return isFinished
    },
    ...mapState(['isPlus'])
  },
  methods: {
    openSelect(type) {
      this.curKey = type
      this.actions = type === 'cp_type' ? this.cpTypeOption : this.teamRoleOption
      this.show = true
    },
    onSelect(evt) {
      this[this.curKey] = evt.name
      this.show = false
    },
    sendSms() {
      this.$emit('sendSms')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.form{
  margin-top: 0;
  .form-item{
    .input{
      color: #222;
    }
  }
}
</style>
